import React, { useState, useEffect } from "react";
import useAxiosPrivate from "../../../../hooks/useAxiosPrivate";
import LeaveBalanceAutoIncrementList from "./LeaveBalanceAutoIncrementList";
import PreferenceTab from "../../../Assets/AssetsTab/PreferenceTab";
import PageLoader from "../../../PageLoader/PageLoader";
import { Link } from "react-router-dom";
import { DatePicker } from "antd";
import dayjs from "dayjs";
const LeaveBalanceAutoIncrement = () => {
  const axiosPrivate = useAxiosPrivate();

  const [selectedLeaveType, setSelectedLeaveType] = useState({
    id: null,
    name: null,
  });
  const [leaveTypesList, setLeaveTypesList] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const currentYear = new Date().getFullYear();
  const [selectedYear, setSelectedYear] = useState(currentYear);

  const onYearChange = (date) => {
    //console.log("Selected Year: ", date ? date.year() : null);
    setSelectedYear(date ? date.year() : currentYear);
  };

  const fetchAutoIncrementLeaveTypeList = async () => {
    try {
      setIsLoading(true);

      const response = await axiosPrivate.get(
        `lms/leave/leaveBalanceAutoIncrementList`
      );

      const res = response?.data;

      if (res?.status) {
        setLeaveTypesList(res.leaveTypeList);

        if (res.leaveTypeList.length > 0) {
          setSelectedLeaveType({
            id: res.leaveTypeList[0].id,
            name: res.leaveTypeList[0].leave_name,
          });
        }
      } else {
        setLeaveTypesList([]);
      }
    } catch (err) {
      setLeaveTypesList([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchAutoIncrementLeaveTypeList();
  }, [selectedYear]);

  const handleTabChange = (index) => {
    const selected = leaveTypesList[index];
    setSelectedLeaveType({
      id: selected.id,
      name: selected.leave_name,
    });
  };

  return (
    <>
      <div className="w-full overflow-x-scroll">
        <div className="px-10 py-6">
          <div className="my-2">
            <h2 className="text-lg font-semibold">Auto Increment Leave Balance</h2>
            <p>Customize all auto increment leave balances</p>
          </div>
<DatePicker
  picker="year"
  value={dayjs(`${selectedYear}`, "YYYY")}
  onChange={onYearChange}
  placeholder="Select year"
  disabledDate={(current) =>
    current && current.year() > new Date().getFullYear()
  }
/>

          {!isLoading && leaveTypesList?.length > 0 && (
            <PreferenceTab
              tabs={leaveTypesList.map((leaveType) => leaveType.leave_name)}
              getTabIndex={handleTabChange}
            />
          )}

          {isLoading ? (
            <PageLoader />
          ) : leaveTypesList?.length > 0 ? (
            <LeaveBalanceAutoIncrementList
              selectedLeaveType={selectedLeaveType}
              selectedYear={selectedYear}
              refreshTypeList={fetchAutoIncrementLeaveTypeList}
            />
          ) : (
            <div className="flex justify-center pt-20">
              <div>
                There are currently no leave types with auto increment enabled.
                <br />
                Please enable it in{" "}
                <Link to="/leave/settings/leave-type" className="text-blue-600 underline">
                  Leave Type and Policy
                </Link>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default LeaveBalanceAutoIncrement;
